module.exports = __webpack_public_path__ + "static/media/Eco-paciente.e43f0240.svg";